<template>
  <div class="ub ub-ver flow-log-div">
    <table-wrapper
      :pagination="pagination"
      @onTableChange="onTableChange"
      :loading="loading"
      :showCheckbox="false"
      :dataSource="dataSource"
      :columns="columns"
    >
      <template #nextTenantUserRealName="{ record }">{{
        Array.isArray(record.nextTenantUserRealName)
          ? record.nextTenantUserRealName.join("，")
          : record.nextTenantUserRealName
      }}</template>
    </table-wrapper>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import { ApprovalFlowLogService } from "./approval-flow-log.service";
import { ApprovalFLowLogPageReq } from "./approval-flow-log.interface";
import { columns } from "./constant";
import { useFlowEmitter } from "@/utils/emitter";
export default defineComponent({
  isGlobal: true,
  name: "ApprovalFlowLog",

  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    eventName: {
      type: String,
    },
  },

  setup(props, { emit }) {
    const { onEvent } = useFlowEmitter();

    const queryRef = reactive(new ApprovalFLowLogPageReq());
    const { data: dataSource, loading, run, pagination,refresh } = ApprovalFlowLogService.usePageApi();

    const search = async () => {
      queryRef.current = 1;
      queryRef.bizId = props.bizId;
      queryRef.bizType = props.bizType;
      await run(queryRef);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };
    onMounted(async () => {
     await search();
      onEvent(async (o) => {
        //只触发组件名称一直的事件，且不是列表审核组件自身发起的
        if (o.eventName === props.eventName && !o.isSelf) {
          await refresh();
        }
      });
    });

    return {
      columns,
      dataSource,
      loading,
      run,
      pagination,
      onTableChange,
    };
  },
});
</script>

<style scoped lang="less">
.flow-log-div{
  background-color: #ffffff; 
  padding: 24px; 
  box-sizing: border-box;
}
</style>